import {
    Box,
    Card,
    CardContent,
    Typography,
    Avatar,
    Divider,
} from '@mui/material';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import { fmt, percentages } from './oneRepMaxUtils';

function ErgebnisKarte({ result }) {
    return (
        <Card>
            <CardContent sx={{ p: 2 }}>
                <Box display="flex" alignItems="center" mb={1.5}>
                    <Avatar sx={{ bgcolor: 'primary.dark', mr: 1, width: 32, height: 32 }}>
                        <EmojiEventsIcon fontSize="small" />
                    </Avatar>
                    <Typography variant="subtitle2" color="text.primary">
                        Ergebnis
                    </Typography>
                    <Typography variant="caption" color="text.secondary" sx={{ ml: 'auto' }}>
                        {result.weight} kg × {result.reps} Wdh.
                    </Typography>
                </Box>
                <Divider sx={{ mb: 2 }} />

                <Box textAlign="center" mb={2}>
                    <Typography
                        sx={{
                            fontSize: 'clamp(56px, 20vw, 80px)',
                            fontWeight: 900,
                            color: 'primary.light',
                            lineHeight: 1,
                            letterSpacing: '-0.04em',
                        }}
                    >
                        {fmt(result.orm)}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                        kg geschätzter 1RM
                    </Typography>
                </Box>

                <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{
                        textTransform: 'uppercase',
                        letterSpacing: '0.12em',
                        display: 'block',
                        mb: 1,
                    }}
                >
                    Trainingsgewichte
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                    {percentages.map(pct => {
                        const w = result.orm * pct / 100;
                        const isMax = pct === 100;
                        return (
                            <Box
                                key={pct}
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    px: 1.5,
                                    py: 0.75,
                                    borderRadius: '8px',
                                    bgcolor: isMax
                                        ? 'rgba(59, 130, 246, 0.08)'
                                        : 'background.default',
                                    border: isMax
                                        ? '1px solid rgba(59, 130, 246, 0.25)'
                                        : '1px solid transparent',
                                }}
                            >
                                <Typography
                                    variant="body2"
                                    sx={{
                                        color: isMax ? 'primary.light' : 'text.secondary',
                                        fontWeight: isMax ? 700 : 400,
                                    }}
                                >
                                    {pct}%
                                </Typography>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        color: isMax ? 'primary.light' : 'text.primary',
                                        fontWeight: isMax ? 700 : 600,
                                    }}
                                >
                                    {fmt(w)} kg
                                </Typography>
                            </Box>
                        );
                    })}
                </Box>
            </CardContent>
        </Card>
    );
}

export default ErgebnisKarte;
